import React from "react";
import "./mainNav.styles.css";
import { Link } from "react-router-dom";

const Nav = ({ page }) => {
  return (
    <div className="navv">
      <nav className="container" role="navigation" aria-label="Main navigation">
        <ul className="nav-listt">
          <li className="nav-itemm">
            <Link
              to={"/"}
              href="#"
              className={`nav-linkk ${page == "home" ? "active" : ""}`}
              aria-current={page === "home" ? "page" : undefined}
            >
              Home
            </Link>
          </li>
          <li className="nav-itemm">
            <Link
              to={"/about"}
              href="#"
              className={`nav-linkk ${page == "about" ? "active" : ""}`}
            >
              About
            </Link>
          </li>
          <li className="nav-itemm">
            <Link
              to={"/ourtalents"}
              href="#"
              className={`nav-linkk ${page == "our talents" ? "active" : ""}`}
            >
              Our Talents
            </Link>
          </li>
          <li className="nav-itemm">
            <Link
              to={"/clients"}
              href="#"
              className={`nav-linkk ${page == "clients" ? "active" : ""}`}
            >
              Clients
            </Link>
          </li>
          <li className="nav-itemm">
            <Link
              to={"/blog"}
              href="#"
              className={`nav-linkk ${page == "blog" ? "active" : ""}`}
            >
              What's New
            </Link>
          </li>
          <li className="nav-itemm">
            <Link
              to={"/contact"}
              href="#"
              className={`nav-linkk ${page == "contact" ? "active" : ""}`}
            >
              Contact
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Nav;
